module.exports = __webpack_public_path__ + "img/403.ae440358.png";